module.exports = __webpack_public_path__ + "e04b264170dfad06e14010ea3e98e50a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fiserv_2022_chart.png
// module id = 1679
// module chunks = 0